(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Championships
   *
   * @description
   *
   */
  angular
      .module('neo.services')
      .factory('Championships', Championships);

  function Championships($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/championships');
  }
}());
